import React, {Component} from 'react';
import {getFootprint} from '../actions/Footprints.js';
import {GeoJSON, Map, Marker, Popup, TileLayer} from 'react-leaflet';
import {Loader, Icon} from 'semantic-ui-react';
import {connect} from 'react-redux';
import axios from 'axios';
import 'leaflet/dist/leaflet.css';
import leaflet from 'mapbox.js';

const TILE_URL='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
const TILE_ATTRIBUTION='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'

class SiteMap extends Component {
  static propTypes = {
    lat: React.PropTypes.number,
    lng: React.PropTypes.number,
    footprints: React.PropTypes.array
  }
  static defaultProps = {
    lat: 0.0,
    lng: 0.0,
    footprints: []
  }

  state = {
    loadedShapes: {}
  }

  componentWillMount() {
    this.loadShapes();
  }
  componentWillReceiveProps(props) {
    console.log("Old props:", this.props);
    console.log("New props:", props);
    if (props.footprints !== this.props.footprints) {
      this.setState({footprints: props.footprints});
      //      console.log("Set new props:", this.props.footprints);
      this.loadShapes(props.footprints)
    }
  }

  loadFootprint(name) {
    this.props.loadFootprint(name);
    //return new Promise((resolve) => {
      //      axios.get('/geojson/' + name).then((response) =>  {
      //        console.log("Loaded " + name);
      //        var data = response.data;
      //        //        data.features = data.features.reverse();
      //        for (let feature of data.features) {
      //          feature.properties['fill-opacity'] = 0.9 / data.features.length;
      //        }
      //        resolve({name: name, data: data});
      //      });
      //    });
  }

  loadShapes(footprints = null) {
    if (footprints === null) footprints = this.props.footprints;
    for (let footprint of footprints) {
      this.loadFootprint(footprint);
    }
  }

  onEachFeature(feature, layer) {
    var content = (
      <h1>TesT</h1>
    );
    console.log(content);
    layer.bindPopup(
     content 
    );
    console.log(feature, layer);
  }

  render() {
    var shapes=[];

    if (this.props.footprints) {
      for (let index in this.props.footprints) {
        const shape = this.props.footprints[index];
        if (this.props.loadedFootprints[shape]) {
          shapes.push(this.props.loadedFootprints[shape]);
        }
      }
    }

    const layerStyle = leaflet.mapbox.simplestyle.style; 

    var loader;

    if (shapes.length !== this.props.footprints.length) {
      loader = <Loader size='huge'>Loading footprints…</Loader>;
    }

    return (
      <div >
        {loader}
        <Map center={[this.props.lat, this.props.lng]} zoom={2} style={{height: 500}}>
          <TileLayer url={TILE_URL} attribution={TILE_ATTRIBUTION} zIndex={42}/>
          {shapes.map((shape, index) => {
            return (<GeoJSON key={shape} data={shape} onEachFeature={this.onEachFeature} style={layerStyle}>
                      <Popup>
                        <span>{index}</span>
                      </Popup>
                   </GeoJSON>);
            })}
          <Marker position={[this.props.lat, this.props.lng]}>
            <Popup>
              <span><Icon name='wifi' />Yay!</span>
            </Popup>
          </Marker>
        </Map>
      </div>
    )
  }
}

var mapDispatchToProps = (dispatch) => {
  return {
    loadFootprint: (name) => {
      dispatch(getFootprint(name)); 
    }
  };
};

var mapStateToProps = (s, ownProps) => {
  return {
    loading: s.footprints.loading,
    loadedFootprints: s.footprints.footprints||{},
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteMap);



// WEBPACK FOOTER //
// ./src/components/SiteMap.js